//import { firestoreAction } from "@/store/firestoreBinding";
import firebase from "firebase/compat/app";
import "firebase/compat/storage";

export const UploadService = {
  actions: {
    async uploadImage(baseUrl, imageData) {
      return new Promise((resolve, _reject) => {
        firebase
          .storage()
          .ref(`${baseUrl}/${imageData.name}`) // Use baseUrl to include the correct folder
          .put(imageData)
          .then(async (r) => {
            r.ref
              .getDownloadURL()
              .then((url) => {
                resolve({
                  success: true,
                  url: url,
                  imageName: imageData.name,
                });
              })
              .catch((e) => {
                resolve({
                  success: false,
                  msg: e.message,
                });
              });
          })
          .catch((e) => {
            resolve({
              success: false,
              msg: e.message,
            });
          });
      });
    },
    async deleteImage(baseUrl, imageName) {
      return new Promise((resolve, _reject) => {
        firebase
          .storage()
          .ref(`${baseUrl}/${imageName}`) // Use baseUrl to include the correct folder
          .delete()
          .then(() => {
            resolve({
              success: true,
            });
          })
          .catch((e) => {
            resolve({
              success: false,
              msg: e.message,
            });
          });
      });
    },
    async uploadFile(baseUrl, fileData) {
      return new Promise((resolve, _reject) => {
        firebase
          .storage()
          .ref(`${baseUrl}/${fileData.name}`)
          .put(fileData)
          .then(async (r) => {
            r.ref
              .getDownloadURL()
              .then((url) => {
                resolve({
                  success: true,
                  url: url,
                  fileName: fileData.name,
                });
              })
              .catch((e) => {
                resolve({
                  success: false,
                  msg: e.message,
                });
              });
          })
          .catch((e) => {
            resolve({
              success: false,
              msg: e.message,
            });
          });
      });
    },
  },
};
